<template>
  <div class="relative flex flex-col items-center justify-center h-48 w-full rounded border-2 border-gray-300 border-dashed">
    <svg class="mx-auto h-10 w-10 mb-2 text-gray-400 feather feather-file-plus" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="12" y1="18" x2="12" y2="12"></line><line x1="9" y1="15" x2="15" y2="15"></line></svg>
    <label for="file" class="text-gray-500"><a href="#" class="text-teal-600 font-semibold">Upload a .jpg, .png or .bmp image</a> or drag and drop</label>
    <div :class="['opacity-50 absolute top-0 left-0 w-full h-full', { 'bg-blue-200': dragging }]"></div>
    <input id="file" class="opacity-0 absolute top-0 left-0 w-full h-full outline-none cursor-pointer" type="file" multiple @input="uploadFiles" @drop.prevent="addFile" @dragenter="dragging = true" @dragleave="dragging = false" @dragover.prevent>
  </div>
</template>

<script>
import { useToast } from "vue-toastification"
export default {
  setup() {
      return {
        toast: useToast()
      }
  },

  data() {
    return {
      dragging: false
    }
  },

  methods: {
    addFile(e) {
      this.dragging = false;
      const droppedFiles = e.dataTransfer.files;
      if(!droppedFiles) return;
      const allowedFiles = this.filterBigFiles(droppedFiles);
      this.emitFiles(allowedFiles);
    },

    async uploadFiles(e) {
      e.stopPropagation();
      const uploadedFiles = e.target.files;
      if(!uploadedFiles) return;
      const allowedFiles = await this.filterFiles(uploadedFiles);
      this.emitFiles(allowedFiles);
    },

    filterFiles(fileElements) {
      const files = [...fileElements]
      return this.filterBigFiles(files).then(allowedFiles => this.filterFileTypes(allowedFiles))
    },

    filterBigFiles(files) {
      return Promise.resolve(files.reduce((acc, file) => {
        if (file.size / 1024 < 5120) {
          acc.push(file)
        } else {
          const message = `${file.name} could not be uploaded because it is larger than 5mb`
          this.toast.error(message)
        }
        return acc;
      }, []))
    },

    filterFileTypes(files) {
      return Promise.resolve(files.reduce((acc, file) => {
        if (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/bmp') {
          acc.push(file)
        } else {
          const message = `${file.name} is not an allowed image format. Only JPEG, PNG or BMP formats are allowed at this moment`
          this.toast.error(message)
        }
        return acc;
      }, []))
    },

    emitFiles(files) {
      files.forEach(f => {
        this.$emit('input', f)
      });
    }
  }
}
</script>

<style>

</style>